// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - Plan
 * Plan
 */
@model({name: 'Plan'})
export class Plan {
  constructor(data?: Partial<Plan>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  pk: string;

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  sk: string;

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  name: string;

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'number',
    },
  })
  price: number;

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  billingPeriod: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'number',
    },
  })
  maxAPIKeys?: number;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'number',
    },
  })
  maxMiniApps?: number;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'object',
    },
  })
  rateLimits?: {};

  /**
   * minimum duration to begin the plan, in terms of number of months
   */
  @property({
    jsonSchema: {
      type: 'string',
      description:
        'minimum duration to begin the plan, in terms of number of months',
    },
  })
  minBuy?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifier?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  description?: string;

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  allowedScopes?: string[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  disallowedScopes?: string[];

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  userId?: string;

  /**
   * Timestamp of request created
   */
  @property({
    jsonSchema: {
      type: 'number',
      description: 'Timestamp of request created',
    },
  })
  timestamp?: number;

  /**
   * Lock configuration for unlock protocol
   */
  @property({
    jsonSchema: {
      type: 'object',
      description: 'Lock configuration for unlock protocol',
    },
  })
  lockConfig?: {};

  /**
   * Features
   */
  @property({
    jsonSchema: {
      type: 'object',
      description: 'Features',
    },
  })
  features?: {};

  /**
   * configuration for stripe
   */
  @property({
    jsonSchema: {
      type: 'object',
      description: 'configuration for stripe',
    },
  })
  stripeConfig?: {};

  /**
   * Plan expiration time
   */
  @property({
    jsonSchema: {
      type: 'number',
      description: 'Plan expiration time',
    },
  })
  expirationTime?: number;
}

export interface PlanRelations {
  // describe navigational properties here
}

export type PlanWithRelations = Plan & PlanRelations;
